import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const WrapperContainer = styled.div`
  color: ${({ theme }) => theme.text};
  max-width: 1200px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 73px;
  font-family: 'Pretendard', sans-serif;
  padding-bottom: 120px;

  @media (max-width: 1240px) {
    padding: 0 20px;
  }
`;
